"use client"

import { createContext, useContext } from "react"
import type { Country, CountryConfig } from "@/i18n/config"
import { getCountryConfig, defaultCountry } from "@/i18n/config"

const CountryContext = createContext<CountryConfig>(
  getCountryConfig(defaultCountry)!
)

export function CountryProvider({
  country,
  children,
}: {
  country: Country
  children: React.ReactNode
}) {
  const config = getCountryConfig(country) ?? getCountryConfig(defaultCountry)!
  return (
    <CountryContext.Provider value={config}>{children}</CountryContext.Provider>
  )
}

export function useCountry(): CountryConfig {
  return useContext(CountryContext)
}
